module.exports = __webpack_public_path__ + "6a11cc8655856bd80bec51e9b02bcc98.svg";